import { getLabelsByLanguage } from "../../../../utilites/util";
const labels = getLabelsByLanguage();

export const ERROR_CLASS = "xnp-input--has-error";
export const VERIFICATION_ERROR = labels.xnpVerificationError;
export const STORE_ERROR = labels.xnpStoreError;
export const MANDATORY_FIELDS = labels.xnpMandatoryFieldsError;
export const MISC_ERROR = labels.xnpMiscError;
export const LOADING_ERROR = labels.xnpLoadingError;

export enum ConsumerEnum {
  PERSON = "domestic",
  ALIEN_WITH_PERSONAL_ID = "naturalized",
  ALIEN = "foreign",
  DIPLOMAT = "diplomat",
}

export enum BusinessEnum {
  ENTERPRISE = "llc",
  TRADE_REPRESENTATION = "trade",
  HUMANITARIAN_ORGANIZATION = "humanitarian",
  EMBASSY = "embassy",
  RELIGIOUS_PROFILE_ORGANIZATION = "religious",
  ENTREPRENEUR = "entrepreneur",
}

export enum BusinessCustomerEnum {
  AUTHORIZED_PERSON = "authorized",
  RESPONSIBLE_PERSON = "responsible",
}

export enum REGISTRATION_TYPE_VALUES {
  REGISTERED = "registered",
  UNREGISTERED = "unregistered",
}

export enum SERVICE_TYPE_LABELS {
  POSTPAID = "postpaid",
  PREPAID = "prepaid",
}

export enum MNP_STATUS {
  INITIATED = "initiated",
  RATEL_CHECK = "ratel-check",
  OPERATOR_CHECK = "operator-check",
  FINISHED = "finished",
}

export const CONSUMER_TYPE_LABELS = {
  [ConsumerEnum.PERSON]: labels.xnpConsumerTypePerson,
  [ConsumerEnum.ALIEN_WITH_PERSONAL_ID]: labels.xnpConsumerTypeForeignerWithId,
  [ConsumerEnum.ALIEN]: labels.xnpConsumerTypeForeigner,
  [ConsumerEnum.DIPLOMAT]: labels.xnpConsumerTypeDiplomat,
} as const;

export const BUSINESS_CUSTOMER_TYPE_LABELS = {
  [BusinessCustomerEnum.AUTHORIZED_PERSON]: labels.xnpBusinessConsumerTypeAuthorized,
  [BusinessCustomerEnum.RESPONSIBLE_PERSON]: labels.xnpBusinessConsumerTypeResponsible,
} as const;

export const BUSINESS_TYPE_LABELS = {
  [BusinessEnum.ENTERPRISE]: labels.xnpBusinessTypeEnterprise,
  [BusinessEnum.TRADE_REPRESENTATION]: labels.xnpBusinessTypeTradeRepresentation,
  [BusinessEnum.HUMANITARIAN_ORGANIZATION]: labels.xnpBusinessTypeHumanitarianOrganization,
  [BusinessEnum.EMBASSY]: labels.xnpBusinessTypeEmbassy,
  [BusinessEnum.RELIGIOUS_PROFILE_ORGANIZATION]: labels.xnpBusinessTypeReligiousProfileOrganization,
  [BusinessEnum.ENTREPRENEUR]: labels.xnpBusinessTypeEnterpreneur,
} as const;

export enum REGISTRATION_TYPE_LABELS {
  REGISTERED = labels.xnpRegisteredType,
  UNREGISTERED = labels.xnpUnRegisteredType,
}

export const serviceTypeOptions = [
  { label: SERVICE_TYPE_LABELS.POSTPAID, value: SERVICE_TYPE_LABELS.POSTPAID },
  { label: SERVICE_TYPE_LABELS.PREPAID, value: SERVICE_TYPE_LABELS.PREPAID },
];

export const registrationOptions = [
  {
    label: REGISTRATION_TYPE_LABELS.REGISTERED,
    value: REGISTRATION_TYPE_VALUES.REGISTERED,
  },
  {
    label: REGISTRATION_TYPE_LABELS.UNREGISTERED,
    value: REGISTRATION_TYPE_VALUES.UNREGISTERED,
  },
];

